<template>
  <div class="dayBudget">
    <el-radio-group v-model="radio">
      <el-radio :label="true">推荐</el-radio>
      <el-radio :label="false">自定义</el-radio>
    </el-radio-group>
    <el-slider v-model="sliderValue" v-if="radio" :min="100" :max="max" :marks="marks" :step="100"
      :format-tooltip="formatTooltip" @input="dragDrop" @change="dragDrop">
    </el-slider>
    <el-input v-else v-model.number="inputValue" placeholder="输入日预算，大于300的整数" @blur="validation"></el-input>
  </div>
</template>

<script>

export default {
  name: "dayBudget",
  props: ["onlinePlanDetails"],
  data() {
    return {
      radio: true,
      sliderValue: 0,
      inputValue: "",
      max: 500,
      marks: {
        100: {
          label: "￥300/天",
          value: 300
        },
        200: {
          label: "￥500/天",
          value: 500
        },
        300: {
          label: "￥800/天",
          value: 800
        },
        400: {
          label: "￥1000/天",
          value: 1000
        },
        500: {
          label: "￥2000/天",
          value: 2000
        }
      },
    }
  },
  watch: {
    onlinePlanDetails: {
      handler(val) {
        let { budget } = val
        let { marks } = this
        let keysList = Object.keys(marks)
        if (budget) {
          let key = keysList.find(item => {
            return marks[item].value === budget
          })
          if (key) {
            this.radio = true
            this.sliderValue = key - 0
          } else {
            this.radio = false
            this.inputValue = budget
          }
        } else {
          this.radio = true
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    formatTooltip(value) {
      let { marks } = this
      let message = marks[value]?.value
      return message
    },
    dragDrop(val) {
      this.sliderValue = val;
    },
    validation() {
      let { inputValue, radio } = this
      let boolean = new RegExp("^[1-9][0-9]*$").test(inputValue);
      if ((!boolean || inputValue < 300) && !radio) {
        this.$message.warning("请输入大于300的正整数");
        this.inputValue = "";
        return false;
      }
      return true;
    },
    getData() {
      let { radio, sliderValue, inputValue, marks } = this
      let sliderValueCopy = marks[sliderValue].value
      let budget = radio ? sliderValueCopy : inputValue
      return {
        budget
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.dayBudget {
  display: flex;
  flex-direction: column;
  align-items: center;

  ::v-deep  .el-radio-group {
    margin-bottom: 50px;
  }

  ::v-deep  .el-slider {
    width: 60%;

    .el-slider__runway {
      background: #efefef;

      .el-slider__bar {
        display: none;
      }

      .el-slider__stop {
        height: 14px;
        width: 14px;
        border: 1px solid #dcdee3;
        top: -4px;
      }

      .el-slider__marks-text {
        width: 64px;
      }

      .el-slider__button-wrapper {
        .el-slider__button {
          background-color: #409eff;
        }
      }
    }
  }

  ::v-deep  .el-input {
    width: 500px;
  }
}
</style>
